import React, { useState, useContext } from 'react';
import { API, AuthContext } from '@/App';
import { MapPin } from 'lucide-react';

// Single source of truth for rendering a service-location image across the App Hub.
// Always resolves from the AUTHORITATIVE service_locations.image_url via the
// central serving endpoint. When no image exists (or it fails to load), every
// screen shows the SAME neutral fallback (map-pin on slate) — never a broken
// image, a pediatric-specific placeholder, or an app-specific copy.
export const LocationImage = ({ locationId, imageUrl, name, className = '', rounded = 'rounded-md', testId, iconSize = 18, variant }) => {
  const { token } = useContext(AuthContext);
  const [failed, setFailed] = useState(false);

  const showImg = !!locationId && !!imageUrl && !failed;
  const src = showImg
    ? `${API}/service-locations/${locationId}/image?auth=${token}${variant ? `&variant=${variant}` : ''}&v=${(imageUrl || '').slice(-16)}`
    : null;

  if (showImg) {
    return (
      <img
        src={src}
        alt={name || 'Service location'}
        className={`object-cover ${rounded} ${className}`}
        data-testid={testId}
        onError={() => setFailed(true)}
      />
    );
  }
  return (
    <div
      className={`flex items-center justify-center bg-slate-100 text-slate-300 ${rounded} ${className}`}
      data-testid={testId ? `${testId}-fallback` : undefined}
      aria-label={name ? `${name} (no image)` : 'No location image'}
    >
      <MapPin size={iconSize} />
    </div>
  );
};

export default LocationImage;
